<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" :absolute="false" />
    <v-row no-gutters class="mt-2 mb-3">
      <v-col cols="12" md="9">
        <h2>
          {{ prasymasTitle
          }}<el-tooltip
            inline
            :tooltip="aprasymasTooltip"
            external
            @activate="
              eventPayload => showAprasymas(eventPayload, aprasymasTooltip)
            "
          />
        </h2>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <el-button v-if="showToList" @click.native="toList()" x-small>{{
          $t('Grįžti į sąrašą')
        }}</el-button>
        <div class="mt-2 busena-link" @click="toAsmenys()">
          <el-prasymas-busena
            class="busena-active"
            :busena="prasymasBusenaTitle"
          />
        </div>
      </v-col>
    </v-row>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="paslaugaAprasymas"
        @close="hideAprasymas"
      />
    </div>

    <el-paslauga-santrauka
      v-if="showLaukiaPasirasymoInfo"
      class="mt-5"
      :tooltip="`NtrPaslaugos. Laukia pasirašymo. Anotacija`"
    />

    <el-paslauga-step :step="step" :steps="steps" @gotoStep="gotoStep" />

    <check-errors ntr-paslaugos />
    <v-card class="pa-0" flat>
      <v-card-text class="pa-0">
        <template v-if="isStepAsmenys">
          <h3 class="mb-0">{{ $t('Asmenys') }}</h3>
          <prasymas-asmenys :readonly="isReadonlyForm" />
        </template>
        <template v-if="isStepTurtas">
          <h3 class="mb-0">{{ $t('Nekilnojamasis turtas') }}</h3>
          <prasymas-turtas :readonly="isReadonlyForm" />
        </template>
        <template v-if="isStepSutartis">
          <h3 class="mb-0">{{ $t('Sutarties dokumento duomenys') }}</h3>
          <prasymas-sutartis :readonly="isReadonlyForm" />
        </template>
        <template v-if="isStepRegistravimas">
          <prasymas-registravimas :readonly="isReadonlyForm" />
        </template>
      </v-card-text>
    </v-card>

    <modal-ntr-busena
      :key="modalBusenaKey"
      v-model="showModalBusena"
      :busena="modalBusena"
      :busena-tekstui="modalBusenaTekstui"
      :is-sign="modalBusenaWithSign"
      @confirmBusena="confirmBusena"
    />

    <v-footer class="form-footer">
      <el-button
        v-if="validate('Tęsti')"
        primary
        @click.native="gotoNextStep()"
        :loading="loading"
        >{{ $t('Tęsti') }}</el-button
      >
      <el-button
        v-if="validate('Patvirtinti savitarna')"
        primary
        @click.native="openBusena('perduotas')"
        :loading="loading"
        >{{ $t('Patvirtinti') }}</el-button
      >
      <el-button
        v-if="validate('Pasirasyti savitarna')"
        primary
        @click.native="openBusena('perduotas')"
        :loading="loading"
        >{{ $t('Pasirašyti') }}</el-button
      >
      <el-button
        v-if="validate('Apmoketi savitarna')"
        primary
        @click.native="moketiSavitarna()"
        :loading="loading"
        >{{ $t('Mokėti') }}</el-button
      >
      <el-button
        v-if="validate('Netvirtinti savitarna')"
        @click.native="openBusena('rengiamas')"
        :loading="loading"
        >{{ $t('Netvirtinti') }}</el-button
      >
      <el-button
        v-if="validate('Atgal')"
        @click.native="gotoPrevStep()"
        :loading="loading"
        >{{ $t('Atgal') }}</el-button
      >

      <v-spacer></v-spacer>

      <el-button
        v-if="validate('Tikrinti savitarna')"
        primary
        @click.native="checkNtrErrors()"
        :loading="loading"
        >{{ $t('Tikrinti') }}</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import NtrPaslaugosMap from './NtrPaslaugosMap'
import CheckErrors from '../hipoteka/CheckErrors'
import PrasymasAsmenys from './PrasymasAsmenys'
import PrasymasTurtas from './PrasymasTurtas'
import PrasymasSutartis from './PrasymasSutartis'
import PrasymasRegistravimas from './PrasymasRegistravimas'
import userRole from '@/mixins/userRole'
import checkErrors from '@/mixins/checkErrors'
import prasymasSteps from '@/mixins/prasymasSteps'
import prasymasVeiksmas from '@/mixins/prasymasVeiksmas'
import ModalNtrBusena from '../modals/ModalNtrBusena'

export default {
  name: 'SubnuomaPrasymas',
  components: {
    PrasymasAsmenys,
    PrasymasTurtas,
    PrasymasSutartis,
    PrasymasRegistravimas,
    CheckErrors,
    ModalNtrBusena,
  },
  mixins: [userRole, checkErrors, prasymasVeiksmas, prasymasSteps],
  data() {
    return {
      pageloading: true,
      loading: false,
      prasymas: {},
      paslaugaAprasymas: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasReadonly', 'listInfo']),
    isReadonlyForm() {
      return this.prasymas.pra_readonly
    },
    steps() {
      return [
        {
          value: 'asmenys',
          label: '1',
          text: this.$t('Asmenys'),
        },
        {
          value: 'turtas',
          label: '2',
          text: this.$t('Nekilnojamasis turtas'),
        },
        {
          value: 'sutartis',
          label: '3',
          text: this.$t('Sutarties dokumento duomenys'),
        },
        {
          value: 'registravimas',
          label: '4',
          text: this.$t('Paslaugos užsakymo informacija'),
        },
      ]
    },
    prasymasTipas() {
      return this.prasymas.pra_tipas
    },
    prasymasBusena() {
      return this.prasymas.pra_busena
    },
    prasymasTitle() {
      return NtrPaslaugosMap.getPrasymasTipas(this.prasymasTipas).title
    },
    prasymasBusenaTitle() {
      return NtrPaslaugosMap.getPrasymasBusena(this.prasymasBusena).title
    },
    showToList() {
      return this.listInfo.prasymasID === this.prasymasID
    },
    aprasymasTooltip() {
      if (this.isPrasymasIsregistravimas) {
        return 'NtrPaslaugos. Subnuoma išregistravimas. Anotacija'
      }
      if (this.isPrasymasNutraukimas) {
        return 'NtrPaslaugos. Subnuoma nutraukimas. Anotacija'
      }
      return 'NtrPaslaugos. Subnuoma įregistravimas. Anotacija'
    },
  },
  beforeCreate() {
    this.$root.$off('reloadPrasymasTab')
  },
  beforeDestroy() {
    this.$store.dispatch('unlockPra', {
      pra_id: this.prasymasID,
      lock: false,
    })
  },
  created() {
    this.$root.$on('reloadPrasymasTab', () => {
      this.getData()
    })
    if (this.$route.params.prasymasID) {
      this.$store.dispatch('prasymasID', this.$route.params.prasymasID)
    }
    this.$store.dispatch('checkErrors', null)
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/prasymastab`)
        .then(res => {
          this.prasymas = res.data.prasymas
          this.$store.dispatch('prasymasSistema', this.prasymas.sistema)
          this.$store.dispatch('prasymasTipas', this.prasymas.pra_tipas)
          this.$store.dispatch('prasymasBusena', this.prasymas.pra_busena)
          this.$store.dispatch('prasymasReadonly', this.prasymas.pra_readonly)
          this.$store.dispatch('prasymasOwner', this.prasymas.is_owner)
          this.$store.dispatch('prasymasSignStatus', this.prasymas.sign_status)
          this.$store.dispatch(
            'prasymasTeikejasRole',
            this.prasymas.teikejas_role
          )

          this.$store.dispatch('lockPra', {
            pra_id: this.prasymasID,
            lock: !this.pra_readonly,
          })
          this.$store.dispatch('activeTooltip', '')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    toList() {
      this.$router.push({
        name: this.listInfo.routeName,
        params: {
          toList: true,
        },
      })
    },
    toAsmenys() {
      if (
        this.prasymasBusena ===
        NtrPaslaugosMap['prasymasBusena'].laukia_patvirtinimo.key
      ) {
        this.gotoAsmenys()
      }
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.busena-link {
  display: inline-block;
}
.busena-active {
  cursor: pointer;
}
</style>
